<template>
  <div class="MyConcern">
      <template v-if="myConcernList && myConcernList.length == 0">
        <div class="null">
          <img src="../../../../common/images/search/search-null.png" alt="">
          <p>当前暂无关注的机构</p>
        </div>
      </template>
      <template v-else>
        <div class="main">
            <el-table :data="myConcernList" style="width: 100%">
            <el-table-column label="机构名称" width="300">
              <template slot-scope="scope">
                <div class="courses-card">
                  <div class="img"><img v-lazy="scope.row.logourl" :alt="scope.row.orgname"></div>
                  <div class="msg">
                    <p class="overflow">{{scope.row.orgname}}</p>
                    <img v-if="scope.row.verifytype == 2" class="rz" src="../../../../common/images/organ/grrz.png">
                    <!-- 个人认证 -->
                    <img v-else class="rz" src="../../../../common/images/organ/qyrz.png">
                    <!-- 企业认证 -->
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="活动数" align="center">
                <template slot-scope="scope">
                    <span class="count" @click="gotoRouterDetaills(scope.row,1)">{{scope.row.eventcount}}</span>
                </template>
            </el-table-column>
            <el-table-column label="课程数" align="center">
                <template slot-scope="scope">
                    <span class="count" @click="gotoRouterDetaills(scope.row,2)">{{scope.row.coursecount}}</span>
                </template>
            </el-table-column>
            <el-table-column label="粉丝数" prop="fanscount" align="center"></el-table-column>
            <!--<el-table-column label="好评度">-->
              <!--<template slot-scope="scope">{{scope.row.feedback}}%</template>-->
            <!--</el-table-column>-->
            <el-table-column label="操作" align="right">
              <template slot-scope="scope">
                 <div class="position">
                  <span @click="canceluploadCourseHostFollowUsing(scope.row.innerid)">取消关注</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="prev, pager, next" :current-page.sync='myConcernListApi.page'  @current-change="handleCurrentChange" :total="rowCount"> </el-pagination>
        </div>
      </template>
      
  </div>
</template>

<script>
import {mapGetters,mapActions} from 'vuex'
import {getMyFollowHostList} from 'api/personalCenterApi'
import {uploadCourseHostFollow} from 'api/api'
export default {
  name: 'MyConcern',
  data () {
    return {
      myConcernList: [],
      myConcernListApi: {page: 1, pageSize: 10},  // 接口api
      rowCount: 1,
    }
  },
  mounted () {
    this.getMyFollowHostLists(1)
  },
  methods: {
    getMyFollowHostLists(page) { // 我的关注列表
      this.myConcernListApi.page = page
      this.setLoading(true)
      getMyFollowHostList({
        data: this.myConcernListApi,
        success: data => {
          this.setLoading(false)
          this.myConcernList = data.data.content
          this.rowCount = data.data.pageinfo.rowCount
          console.log('myConcernList',this.myConcernList)
        },
        error: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })
    },
    canceluploadCourseHostFollowUsing(innerid) {  // 取消关注
      this.$confirm('是否需要取消关注该机构, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.setLoading(true)
          uploadCourseHostFollow({
                data: {optype: 2, hostid: innerid},
                success: data => {
                    this.setLoading(false)
                    if (data.code == '000') {
                      this.$message.success('已取消关注')
                      // 刷新列表
                      this.getMyFollowHostLists(1)
                      // 刷新基本信息统计
                      this.$parent.info()
                    } else {
                        this.$message.error(data.msg)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
          })

      }).catch(() => {})
    },
    handleCurrentChange(page) { // 翻页
        this.getMyFollowHostLists(page)
    },
     gotoRouterDetaills(row,type) {
         if(type===1){ //活动主办方
            // if(row.eventcount<=0){
            //     return
            // }
             if (this.user.loginToken) {
                 window.open(`${this.domainlist.url_hd}/hdHost?hostid=${row.innerid}&token=${this.user.loginToken}`)
             } else {
                 window.open(`${this.domainlist.url_hd}/hdHost?hostid=${row.innerid}`)
             }
         }else if(type===2){ //课程主办方
            // if(row.coursecount<=0){
            //     return
            // }
             if (this.user.loginToken) {
                 window.open(`${this.domainlist.url_course}/organ?hostid=${row.innerid}&token=${this.user.loginToken}`)
             } else {
                 window.open(`${this.domainlist.url_course}/organ?hostid=${row.innerid}`)
             }
         }
    }, 
    ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {},
  computed: {
      ...mapGetters(['loginPop', 'user','domainlist'])
  },
  components: {}
}
</script>

<style lang="scss" type="text/scss" scope>
.MyConcern {
  .el-table {
    .img {
      width: 72px;
      height: 72px;
    }
    .msg {
      margin-top: 9px;
    }
    .rz {
      width: 75px;
      height: 25px;
    }
    .overflow {
      width: 190px;
      display: block;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
    }
    .rz {
      margin-top: 5px;
    }
      .count{
          cursor: pointer;
          color: #409EFF;
      }
  }
}
</style>